import {
  FETCH_BAND_INFO,
  FETCH_MULTI_BANNER_LIST_INFO,
} from '@/store/types/actions.type'
import { EventService, GNBService } from '@/common/api/api.service'
import { get } from 'lodash'
import { GNBDataConverter } from '@/common/converter/ObjectConverter'
import {
  MENU_GLOBAL,
  MENU_HOME,
  MENU_LIVE,
  MENU_MOVIE,
  MENU_MOVIE_17,
  MENU_PLAYY,
  MENU_TV_CUT,
  MENU_VOD,
  MENU_MY,
  MENU_CATEGORY,
} from '@/common/menu/menu.const'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import { hasUserConfirmPPV } from '@/common/util/common'
const SET_MULTI_BANNER_LIST = 'setMultiBannerList'

const getGenTime = (convertedPlainObject) => {
  return get(convertedPlainObject, 'genTime', '')
}

const state = {
  currentMenu: MENU_HOME,
  [MENU_HOME]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_VOD]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_LIVE]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_MOVIE]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_MOVIE_17]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_GLOBAL]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_PLAYY]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_TV_CUT]: {
    GNBData: null,
    multiSectionList: [],
  },
  [MENU_CATEGORY]: {
    GNBData: null,
    multiSectionList: [],
  },
  // 2025.03 MY는 home API(catalog)로 전환했기 때문에 더이상 multiSection에서 관리하지 않음
  [MENU_MY]: {
    GNBData: null,
    multiSectionList: [],
  },
  bandMemorize: {},
  isBandLoading: false,
}

const getters = {
  currentMenu(state) {
    return state.currentMenu
  },
  currentGNBInfo(state) {
    return state[state.currentMenu].GNBData
  },
  multiSectionList(state) {
    return state[state.currentMenu].multiSectionList
  },
  hasMemorize: (state) => (uiCode) => {
    return state.bandMemorize[uiCode] || null
  },
  isBandLoading(state) {
    return state.isBandLoading
  },
}

const actions = {
  async [FETCH_MULTI_BANNER_LIST_INFO](context, { menuName, force = false }) {
    state.isBandLoading = true
    const dynamicMenuName =
      menuName === MENU_MOVIE && hasUserConfirmPPV() ? MENU_MOVIE_17 : menuName
    const existGNBData = get(state[dynamicMenuName], 'GNBData', null)
    let newGNBData = null
    if (existGNBData === null || force) {
      newGNBData = GNBDataConverter(
        await GNBService.setMultiBannerListByMenuName(dynamicMenuName),
      )
      context.commit(SET_MULTI_BANNER_LIST, { GNBData: newGNBData, menuName })
      state.isBandLoading = false
    } else {
      context.commit(SET_MULTI_BANNER_LIST, { GNBData: existGNBData, menuName })
      const existGentTime = getGenTime(existGNBData)
      const newGenTime = getGenTime(newGNBData)
      if (existGentTime !== newGenTime) {
        newGNBData = GNBDataConverter(
          await GNBService.setMultiBannerListByMenuName(dynamicMenuName),
        )
        context.commit(SET_MULTI_BANNER_LIST, {
          GNBData: newGNBData,
          menuName,
        })
        state.isBandLoading = false
      }
    }
  },
  async [FETCH_BAND_INFO](context, { eventModel, force = false }) {
    const uiCode = eventModel.uiCode
    const response = await EventService.requestEventData(eventModel)
    const data = response?.data
    const bandInfo = {
      genTime: get(data, 'gen_time', null),
      cellType: get(data, ['band', 'cell_type'], null),
      cellList: get(data, ['band', 'celllist'], []),
      buttonInfo: get(data, ['band', 'buttoninfo'], null),
    }
    const isInstantPlayBand = data?.band?.cell_type ?? null
    if (!isInstantPlayBand) state.bandMemorize[uiCode] = bandInfo
    return bandInfo
  },
}

const mutations = {
  [SET_CURRENT_MENU](state, menuName) {
    state.currentMenu = menuName
  },
  [SET_MULTI_BANNER_LIST](state, { GNBData, menuName }) {
    state[menuName].GNBData = GNBData
    state[menuName].multiSectionList = get(GNBData, 'multiSectionList', [])
  },
  showLoadingProgress(state) {
    state.isBandLoading = true
  },
  hideLoadingProgress(state) {
    state.isBandLoading = false
  },
}

export default { state, getters, actions, mutations }
